import React, { useState } from "react"
import { hasPremiumPassOrCredits } from "../../helpers/auth"

const UserBar = ({ user, onPremiumClick, onLogout }) => {
  const [expanded, setExpanded] = useState(false)
  const isPremium = hasPremiumPassOrCredits(user)

  return (
    <div className={`auth-user-bar${expanded ? " auth-user-bar-expanded" : ""}`}>
      <button className="auth-user-email-btn" onClick={() => setExpanded((e) => !e)}>
        <span className="auth-user-email">{user.email}</span>
        <span className="auth-expand-icon">{expanded ? "▲" : "▼"}</span>
      </button>
      {expanded && (
        <div className="auth-user-actions">
          <button
            className={`auth-logout-btn${isPremium ? " auth-premium-btn-active" : ""}`}
            onClick={onPremiumClick}
            title="View premium options"
          >
            Premium
            {isPremium && (
              <span className="auth-premium-info">
                {user.premium_pass_active
                  ? `(${user.days_remaining} Days)`
                  : `(${user.premium_credits_remaining} Credits)`}
              </span>
            )}
          </button>
          <button className="auth-logout-btn" onClick={onLogout} title="Sign out of your account">
            Logout
          </button>
        </div>
      )}
    </div>
  )
}

export default UserBar
